import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';
import confirmModal from '../../../../../../common/modals/ConfirmModal/confirmModal.component';

class PaylocityEmployeeMapping {
  constructor($rootScope, $uibModal, $state, $http, $q, $interval, $scope, toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$interval = $interval;
    this.$scope = $scope;
    this.toastr = toastr;

    // Sync progress (from GET /sync/status): inProgress, total, completed, startTimeEpochMillis, message
    this.syncProgress = {
      inProgress: false,
      total: 0,
      completed: 0,
      startTimeEpochMillis: null,
      message: ''
    };
    this._syncPollPromise = null;

    this.unmappedUsers = [];
    this.ignoredUsers = [];
    this.pendingNotifier = null;
    this.notificationRecipients = {
      individualSyncNotificationUserIds: [],
      bulkSyncCompletionNotificationUserIds: [],
      unmappedEmployeeNotificationUserIds: []
    };
    this.availableNotificationUsers = {
      individualSyncNotificationUserIds: [],
      bulkSyncCompletionNotificationUserIds: [],
      unmappedEmployeeNotificationUserIds: []
    };
    this.scheduleHours = _.range(0, 24);
    this.scheduleMinutes = [0, 15, 30, 45];
    this.syncSettings = {
      scheduleEnabled: false,
      scheduleHour: 2,
      scheduleMinute: 0,
      scheduleTimeZone: 'America/New_York',
      notifyOnIndividualSync: true,
      notifyOnBulkSyncComplete: true,
      notifyOnUnmappedEmployeeFound: true,
      individualSyncNotificationUserIds: [],
      bulkSyncCompletionNotificationUserIds: [],
      unmappedEmployeeNotificationUserIds: [],
      lastScheduledRun: null,
      nextScheduledRun: null
    };

    let self = this;
    window.paylocityEmployeeMappingCtrl = self;

    $scope.$on('$destroy', function () {
      if (window.paylocityEmployeeMappingCtrl === self) {
        delete window.paylocityEmployeeMappingCtrl;
      }
      if (self._syncPollPromise) {
        $interval.cancel(self._syncPollPromise);
        self._syncPollPromise = null;
      }
    });

    // Re-render table when sync in-progress changes so Sync buttons enable/disable
    $scope.$watch(function () { return self.syncProgress.inProgress; }, function () {
      if (self.employeeMappingTableData && self.employeeMappingTableData.length) {
        self.employeeMappingTableData = self.employeeMappingTableData.slice();
      }
    });

    // TimeClerk employees not already in the mapping table (for unmapped-section dropdown)
    this.availableEmployeesForMapping = [];

    $scope.$watch(function () { return self.employeeMappingTableData; }, function () {
      self._updateAvailableEmployeesForMapping();
    });
    $scope.$watch(function () { return self.employees; }, function () {
      self._updateAvailableEmployeesForMapping();
    });

    // Define columns for employee mapping table
    this.employeeMappingColumns = [
      {
        displayName: 'TimeClerk Employee',
        value: 'timeclerkEmployee',
        dataType: 'text',
        sortable: true,
        formatting: function(record) {
          return '<strong>' + (record.timeclerkEmployee || '') + '</strong>';
        }
      },
      {
        displayName: 'Paylocity Employee',
        value: 'paylocityEmployee',
        dataType: 'text',
        sortable: true,
        formatting: function(record) {
          const paylocityName = record.paylocityEmployee || 'Click to change mapping';
          return '<i class="fa fa-user"></i> ' + paylocityName + ' <i class="fa fa-edit" style="margin-left: 5px; color: #337ab7; cursor: pointer;" title="Click to edit"></i>';
        },
        clickFunction: function(record) {
          if (record._mappingData) {
            self.openPaylocityEmployeeSelector(record._mappingData);
          }
        }
      },
      {
        displayName: 'Last Synced',
        value: 'lastSynced',
        dataType: 'text',
        sortable: true,
        formatting: function(record) {
          if (record._mappingData && record._mappingData.lastSynced) {
            return moment(record._mappingData.lastSynced).format('MMM DD, YYYY');
          }
          return '<span class="text-muted">Never</span>';
        }
      },
      {
        displayName: 'Actions',
        value: 'actions',
        dataType: 'text',
        sortable: false,
        formatting: function(record) {
          if (record._mappingData && record._mappingData.paylocityEmployeeId) {
            var disabled = self.syncProgress && self.syncProgress.inProgress;
            var paylocityEmployeeId = String(record._mappingData.paylocityEmployeeId).replace(/'/g, "\\'");
            return '<button type="button" class="btn btn-xs btn-info' + (disabled ? ' disabled' : '') + '"' +
                   (disabled ? ' disabled="disabled"' : '') +
                   ' onclick="event.stopPropagation(); window.paylocityEmployeeMappingCtrl.syncEmployeeByPaylocityId(\'' + paylocityEmployeeId + '\')"' +
                   ' title="Force sync with Paylocity">' +
                   '<i class="fa fa-sync"></i> Sync</button> ' +
                   '<button type="button" class="btn btn-xs btn-danger"' +
                   ' onclick="event.stopPropagation(); window.paylocityEmployeeMappingCtrl.removeEmployeeMapping(\'' + paylocityEmployeeId + '\')"' +
                   ' title="Remove mapping">' +
                   '<i class="fa fa-trash"></i> Remove</button>';
          }
          return '';
        }
      }
    ];

    // Load employees and paylocity employees first so names are available when building the mapping table
    var usersPromise = $http.get($rootScope.apiHost + "/api/admin/users/", {withCredentials: true});
    var paylocityEmployeesPromise = $http.get($rootScope.apiHost + "/api/integrations/paylocity/employees", {withCredentials: true});
    var mappingPromise = $http.get($rootScope.apiHost + "/api/integrations/paylocity/employees/mapping", {withCredentials: true});

    $q.all([usersPromise, paylocityEmployeesPromise, mappingPromise]).then(function (results) {
      var usersResp = results[0];
      var paylocityResp = results[1];
      var mappingResp = results[2];

      self.employees = usersResp.data;
      self._prepareEmployeesForDropdown();
      self._updateNotificationLists();

      self.paylocityEmployees = paylocityResp.data;
      self.paylocityEmployees.forEach(function (employee) {
        employee.name = employee.firstName + ' ' + employee.lastName;
      });

      self.employeeMapping = mappingResp.data;
      self._applyMappingResponse(mappingResp.data);
    });

    self._refreshUnmappedUsers();

    this.$http.get($rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
      self.paylocityIntegration = success.data;
      // Initialize employeeSyncEnabled if not present (default to false)
      if (self.paylocityIntegration.employeeSyncEnabled === undefined) {
        self.paylocityIntegration.employeeSyncEnabled = false;
      }
    });

    self._loadSyncSettings();

  }

  _defaultSyncSettings() {
    return {
      scheduleEnabled: false,
      scheduleHour: 2,
      scheduleMinute: 0,
      scheduleTimeZone: 'America/New_York',
      notifyOnIndividualSync: true,
      notifyOnBulkSyncComplete: true,
      notifyOnUnmappedEmployeeFound: true,
      individualSyncNotificationUserIds: [],
      bulkSyncCompletionNotificationUserIds: [],
      unmappedEmployeeNotificationUserIds: [],
      lastScheduledRun: null,
      nextScheduledRun: null
    };
  }

  _applySyncSettingsResponse(data) {
    const defaults = this._defaultSyncSettings();
    const settings = _.extend({}, defaults, data || {});
    settings.individualSyncNotificationUserIds = settings.individualSyncNotificationUserIds || [];
    settings.bulkSyncCompletionNotificationUserIds = settings.bulkSyncCompletionNotificationUserIds || [];
    settings.unmappedEmployeeNotificationUserIds = settings.unmappedEmployeeNotificationUserIds || [];
    this.syncSettings = settings;
    this._updateNotificationLists();
  }

  _updateNotificationLists() {
    this._updateNotificationListForField('individualSyncNotificationUserIds');
    this._updateNotificationListForField('bulkSyncCompletionNotificationUserIds');
    this._updateNotificationListForField('unmappedEmployeeNotificationUserIds');
  }

  _prepareEmployeesForDropdown() {
    (this.employees || []).forEach(function (emp) {
      if (emp && !emp.name) {
        emp.name = (emp.firstName || '') + ' ' + (emp.lastName || '');
      }
    });
  }

  _updateNotificationListForField(fieldName) {
    const ids = (this.syncSettings && this.syncSettings[fieldName]) || [];

    this.notificationRecipients[fieldName] = ids.map((userId) => ({
      id: userId,
      name: this.getEmployeeName(userId)
    }));

    const selectedIds = {};
    ids.forEach(function (id) {
      selectedIds[id] = true;
    });

    // Use the same employee objects as the mapping dropdown (not copies, no email filter)
    this.availableNotificationUsers[fieldName] = (this.employees || []).filter(function (emp) {
      return emp && emp.id != null && !selectedIds[emp.id];
    });
  }

  _loadSyncSettings() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost + "/api/integrations/paylocity/employees/sync/settings", {withCredentials: true}).then(function (res) {
      self._applySyncSettingsResponse(res.data);
    }, function () {
      self._applySyncSettingsResponse(null);
    });
  }

  _buildSyncSettingsPayload() {
    return {
      scheduleEnabled: !!this.syncSettings.scheduleEnabled,
      scheduleHour: parseInt(this.syncSettings.scheduleHour, 10) || 0,
      scheduleMinute: parseInt(this.syncSettings.scheduleMinute, 10) || 0,
      scheduleTimeZone: this.syncSettings.scheduleTimeZone || 'America/New_York',
      notifyOnIndividualSync: !!this.syncSettings.notifyOnIndividualSync,
      notifyOnBulkSyncComplete: !!this.syncSettings.notifyOnBulkSyncComplete,
      notifyOnUnmappedEmployeeFound: !!this.syncSettings.notifyOnUnmappedEmployeeFound,
      individualSyncNotificationUserIds: (this.syncSettings.individualSyncNotificationUserIds || []).slice(),
      bulkSyncCompletionNotificationUserIds: (this.syncSettings.bulkSyncCompletionNotificationUserIds || []).slice(),
      unmappedEmployeeNotificationUserIds: (this.syncSettings.unmappedEmployeeNotificationUserIds || []).slice()
    };
  }

  saveSyncSettings(modalInstance) {
    let self = this;
    const payload = this._buildSyncSettingsPayload();

    this.$http.patch(this.$rootScope.apiHost + "/api/integrations/paylocity/employees/sync/settings", payload, {withCredentials: true}).then(function (res) {
      self._applySyncSettingsResponse(res.data);
      self.toastr.success("Sync schedule and notification settings saved.", "SUCCESS");
      if (modalInstance) {
        modalInstance.close();
      }
    }, function (error) {
      self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to save sync settings.", "ERROR");
    });
  }

  openSyncSettingsModal() {
    let self = this;
    this.pendingNotifier = null;
    this._prepareEmployeesForDropdown();
    this._updateNotificationLists();
    this._loadSyncSettings();

    return this.$uibModal.open({
      size: 'lg',
      template: `
        <div class="modal-header">
          <h4 class="modal-title"><i class="fa fa-clock-o"></i> Sync Schedule &amp; Notifications</h4>
        </div>
        <div class="modal-body">
          <h5 style="margin-top: 0; margin-bottom: 12px;">Scheduled Sync</h5>
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12">
              <label style="font-weight: normal; margin-right: 10px;">Enable daily sync:</label>
              <toggle ng-model="$modal.parent.syncSettings.scheduleEnabled" on="On" off="Off" on-class="btn-success" off-class="btn-default" size="btn-xs"></toggle>
            </div>
          </div>
          <div class="row" ng-if="$modal.parent.syncSettings.scheduleEnabled" style="margin-bottom: 10px;">
            <div class="col-sm-4">
              <label class="small text-muted">Hour</label>
              <select class="form-control input-sm" ng-model="$modal.parent.syncSettings.scheduleHour" ng-options="hour for hour in $modal.parent.scheduleHours"></select>
            </div>
            <div class="col-sm-4">
              <label class="small text-muted">Minute</label>
              <select class="form-control input-sm" ng-model="$modal.parent.syncSettings.scheduleMinute" ng-options="minute for minute in $modal.parent.scheduleMinutes"></select>
            </div>
            <div class="col-sm-4">
              <label class="small text-muted">Time zone</label>
              <input type="text" class="form-control input-sm" ng-model="$modal.parent.syncSettings.scheduleTimeZone" placeholder="America/New_York">
            </div>
          </div>
          <p class="text-muted small" ng-if="$modal.parent.syncSettings.scheduleEnabled" style="margin-bottom: 16px;">
            Last run: {{$modal.formatScheduleRun($modal.parent.syncSettings.lastScheduledRun)}} |
            Next run: {{$modal.formatScheduleRun($modal.parent.syncSettings.nextScheduledRun)}}
          </p>

          <h5 style="margin-bottom: 12px;"><i class="fa fa-bell-o"></i> Notifications</h5>

          <div style="margin-bottom: 14px;">
            <label style="font-weight: normal;">
              <input type="checkbox" ng-model="$modal.parent.syncSettings.notifyOnIndividualSync">
              Notify when an individual employee sync is requested
            </label>
            <div ng-if="$modal.parent.syncSettings.notifyOnIndividualSync" style="margin-top: 8px;">
              <div ng-repeat="recipient in $modal.parent.notificationRecipients.individualSyncNotificationUserIds" style="margin-bottom: 4px;">
                <span class="label label-default" style="display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; padding: 5px 8px;">
                  {{recipient.name}}
                  <button type="button" class="btn btn-link btn-xs" style="padding: 0; color: #fff;" ng-click="$modal.parent.removeNotificationRecipient('individualSyncNotificationUserIds', recipient.id)">&times;</button>
                </span>
              </div>
              <div style="display: flex; gap: 8px; margin-top: 6px;">
                <div style="flex: 1;">
                  <employee-dropdown
                    ng-model="$modal.parent.pendingNotifier"
                    employees="$modal.parent.availableNotificationUsers.individualSyncNotificationUserIds"
                    placeholder="Add TimeClerk user...">
                  </employee-dropdown>
                </div>
                <button class="btn btn-xs btn-default" ng-click="$modal.parent.addNotificationRecipient('individualSyncNotificationUserIds')" ng-disabled="!$modal.parent.pendingNotifier">Add</button>
              </div>
            </div>
          </div>

          <div style="margin-bottom: 14px;">
            <label style="font-weight: normal;">
              <input type="checkbox" ng-model="$modal.parent.syncSettings.notifyOnBulkSyncComplete">
              Notify when the bulk synchronization job completes
            </label>
            <div ng-if="$modal.parent.syncSettings.notifyOnBulkSyncComplete" style="margin-top: 8px;">
              <div ng-repeat="recipient in $modal.parent.notificationRecipients.bulkSyncCompletionNotificationUserIds" style="margin-bottom: 4px;">
                <span class="label label-default" style="display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; padding: 5px 8px;">
                  {{recipient.name}}
                  <button type="button" class="btn btn-link btn-xs" style="padding: 0; color: #fff;" ng-click="$modal.parent.removeNotificationRecipient('bulkSyncCompletionNotificationUserIds', recipient.id)">&times;</button>
                </span>
              </div>
              <div style="display: flex; gap: 8px; margin-top: 6px;">
                <div style="flex: 1;">
                  <employee-dropdown
                    ng-model="$modal.parent.pendingNotifier"
                    employees="$modal.parent.availableNotificationUsers.bulkSyncCompletionNotificationUserIds"
                    placeholder="Add TimeClerk user...">
                  </employee-dropdown>
                </div>
                <button class="btn btn-xs btn-default" ng-click="$modal.parent.addNotificationRecipient('bulkSyncCompletionNotificationUserIds')" ng-disabled="!$modal.parent.pendingNotifier">Add</button>
              </div>
            </div>
          </div>

          <div style="margin-bottom: 0;">
            <label style="font-weight: normal;">
              <input type="checkbox" ng-model="$modal.parent.syncSettings.notifyOnUnmappedEmployeeFound">
              Notify when an unmapped Paylocity employee is found
            </label>
            <div ng-if="$modal.parent.syncSettings.notifyOnUnmappedEmployeeFound" style="margin-top: 8px;">
              <div ng-repeat="recipient in $modal.parent.notificationRecipients.unmappedEmployeeNotificationUserIds" style="margin-bottom: 4px;">
                <span class="label label-default" style="display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; padding: 5px 8px;">
                  {{recipient.name}}
                  <button type="button" class="btn btn-link btn-xs" style="padding: 0; color: #fff;" ng-click="$modal.parent.removeNotificationRecipient('unmappedEmployeeNotificationUserIds', recipient.id)">&times;</button>
                </span>
              </div>
              <div style="display: flex; gap: 8px; margin-top: 6px;">
                <div style="flex: 1;">
                  <employee-dropdown
                    ng-model="$modal.parent.pendingNotifier"
                    employees="$modal.parent.availableNotificationUsers.unmappedEmployeeNotificationUserIds"
                    placeholder="Add TimeClerk user...">
                  </employee-dropdown>
                </div>
                <button class="btn btn-xs btn-default" ng-click="$modal.parent.addNotificationRecipient('unmappedEmployeeNotificationUserIds')" ng-disabled="!$modal.parent.pendingNotifier">Add</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" ng-click="$modal.close()">Cancel</button>
          <button type="button" class="btn btn-primary" ng-click="$modal.save()">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      `,
      controller: ['$uibModalInstance', 'parentCtrl', function ($uibModalInstance, parentCtrl) {
        this.parent = parentCtrl;
        this.formatScheduleRun = function (timestamp) {
          return parentCtrl.formatScheduleRun(timestamp);
        };
        this.close = function () {
          $uibModalInstance.dismiss();
        };
        this.save = function () {
          parentCtrl.saveSyncSettings($uibModalInstance);
        };
      }],
      controllerAs: '$modal',
      resolve: {
        parentCtrl: function () {
          return self;
        }
      }
    });
  }

  addNotificationRecipient(fieldName) {
    if (!this.pendingNotifier || !this.pendingNotifier.id) {
      return;
    }

    const ids = (this.syncSettings[fieldName] || []).slice();
    if (ids.indexOf(this.pendingNotifier.id) === -1) {
      ids.push(this.pendingNotifier.id);
      this.syncSettings[fieldName] = ids;
    }
    this.pendingNotifier = null;
    this._updateNotificationListForField(fieldName);
  }

  removeNotificationRecipient(fieldName, userId) {
    this.syncSettings[fieldName] = (this.syncSettings[fieldName] || []).filter(function (id) {
      return id !== userId;
    });
    this._updateNotificationListForField(fieldName);
  }

  formatScheduleRun(timestamp) {
    if (!timestamp) {
      return 'Not scheduled';
    }
    return moment(timestamp).format('MMM DD, YYYY h:mm A');
  }

  /** Returns true if the mapping links a Paylocity employee to a TimeClerk user. */
  isMappedMapping(mapping) {
    if (!mapping) return false;
    var userId = mapping.timeclerkUserId != null ? mapping.timeclerkUserId : mapping.timeclerkId;
    return userId != null && userId !== 0;
  }

  /** Returns true if the Paylocity employee was explicitly ignored (no TimeClerk mapping). */
  isIgnoredMapping(mapping) {
    if (!mapping) return false;
    var userId = mapping.timeclerkUserId != null ? mapping.timeclerkUserId : mapping.timeclerkId;
    return userId === 0;
  }

  _updateIgnoredUsers() {
    this.ignoredUsers = (this.employeeMapping || []).filter((mapping) => this.isIgnoredMapping(mapping));
  }

  _updateAvailableEmployeesForMapping() {
    var mappedIds = {};
    if (this.employeeMappingTableData && this.employeeMappingTableData.length) {
      this.employeeMappingTableData.forEach((row) => {
        if (row._mappingData && this.isMappedMapping(row._mappingData)) {
          var id = row._mappingData.timeclerkUserId != null ? row._mappingData.timeclerkUserId : row._mappingData.timeclerkId;
          mappedIds[id] = true;
        }
      });
    }
    var list = this.employees || [];
    this.availableEmployeesForMapping = list.filter(function (emp) {
      return !mappedIds[emp.id] && emp.userType.toLowerCase() !== 'contractor' && emp.userType.toLowerCase() !== 'subcontractor';
    });
  }

  _applyMappingResponse(mappingData) {
    this.employeeMapping = mappingData || [];
    this.employeeMappingTableData = this.employeeMapping
      .filter((mapping) => this.isMappedMapping(mapping))
      .map((mapping) => ({
        timeclerkEmployee: this.getEmployeeName(mapping.timeclerkUserId),
        paylocityEmployee: this.getPaylocityEmployeeName(mapping.paylocityEmployeeId),
        lastSynced: mapping.lastSynced || null,
        _mappingData: mapping
      }));
    this._updateIgnoredUsers();
    this._updateAvailableEmployeesForMapping();
  }

  _refreshUnmappedUsers() {
    return this.$http.get(this.$rootScope.apiHost + "/api/integrations/paylocity/employees/unmapped", {withCredentials: true}).then((res) => {
      this.unmappedUsers = res.data || [];
    });
  }

  toggleEmployeeSync() {
    let self = this;
    let obj = {
      employeeSyncEnabled: this.paylocityIntegration.employeeSyncEnabled
    };

    this.$http.patch(this.$rootScope.apiHost+"/api/integrations/paylocity", obj, {withCredentials: true}).then(function (success) {
      self.toastr.success("Employee synchronization " + (self.paylocityIntegration.employeeSyncEnabled ? "enabled" : "disabled") + ".", "Success");
      // Refresh the integration status
      self.$http.get(self.$rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
        self.paylocityIntegration = success.data;
      });
    }, function (failure) {
      self.toastr.error("Could not update employee synchronization setting.", "ERROR");
      // Revert the toggle on error
      self.paylocityIntegration.employeeSyncEnabled = !self.paylocityIntegration.employeeSyncEnabled;
    });
  }

  updatePaylocityMapping(employee) {
    let self = this;
    let tcUid = employee.timeclerkUserId;
    let oldPaylocityId = employee.paylocityEmployeeId;
    let newPaylocityId = employee.paylocityEmployee.paylocityEmployeeId;

    let obj = {
      "paylocityEmployeeId" : newPaylocityId,
      "timeclerkUserId" : tcUid
    };

    this.$http.post(this.$rootScope.apiHost+"/api/integrations/paylocity/employees/mapping", [obj], {withCredentials: true}).then(function (success) {
      self._applyMappingResponse(success.data);
    });
  }

  getEmployeeName(timeclerkId) {
    if (this.employees) {
      var match = _.find(this.employees, { id: timeclerkId });
      return match ? (match.firstName + ' ' + match.lastName) : '';
    }
    return '';
  }

  getPaylocityEmployeeName(paylocityId) {
    if (this.paylocityEmployees) {
      var match = _.find(this.paylocityEmployees, { paylocityEmployeeId: paylocityId });
      return match ? (match.firstNameInPaylocity + ' ' + match.lastNameInPaylocity) : '';
    }
    return '';
  }

  getEmployeeMapping(employee) {
    let mappedEmployee = undefined;

    this.employeeMapping.forEach(function (emp) {
      if(emp.timeclerkUserId == employee.id) {
        mappedEmployee = employee;
        mappedEmployee.name = employee.firstName + ' ' + employee.lastName;
      }
    });

    return mappedEmployee;
  }

  getSuggestedMapping(employee) {

    let suggestedMatch = undefined;

    if(this.paylocityEmployees) {
      this.paylocityEmployees.forEach(function (paylocityEmployee) {
        let employeeName = employee.firstName + employee.lastName;
        let paylocityEmployeeName = paylocityEmployee.firstName + paylocityEmployee.lastName;

        if (employeeName.toLowerCase() === paylocityEmployeeName.toLowerCase()) {
          suggestedMatch = paylocityEmployee;
          suggestedMatch.name = suggestedMatch.firstName + ' ' + suggestedMatch.lastName;
        }

      });
    }

    return suggestedMatch;
  }

  mapEmployee(employee) {
    let self = this;


    let obj = {
      timeclerkUserId : employee.timeclerkEmployee.id,
      paylocityEmployeeId : employee.paylocityEmployeeId,
      firstNameInPaylocity : employee.firstNameInPaylocity,
      lastNameInPaylocity : employee.lastNameInPaylocity
    };


    this.$http.post(self.$rootScope.apiHost+"/api/integrations/paylocity/employees/mapping", [obj], {withCredentials: true}).then(function (success) {
      self._applyMappingResponse(success.data);
      self.toastr.success("User Successfully Mapped!", "SUCCESS");
      self._refreshUnmappedUsers();
    });
  }

  ignoreEmployee(employee) {
    let self = this;
    const employeeName = (employee.firstNameInPaylocity || '') + ' ' + (employee.lastNameInPaylocity || '');

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = "Ignore Paylocity Employee";
    modalInstance.subject = employeeName.trim();
    modalInstance.message = "This Paylocity employee will not be mapped to a TimeClerk user and will be removed from the unmapped list. You can restore them later from the Employee Synchronization panel.";

    modalInstance.yes = function () {
      const obj = {
        timeclerkUserId: 0,
        paylocityEmployeeId: employee.paylocityEmployeeId,
        firstNameInPaylocity: employee.firstNameInPaylocity,
        lastNameInPaylocity: employee.lastNameInPaylocity
      };

      self.$http.post(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/mapping", [obj], {withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self._applyMappingResponse(success.data);
        self._refreshUnmappedUsers();
        self.toastr.success("Paylocity employee ignored.", "SUCCESS");
      }, function (error) {
        modalInstance.dismiss();
        self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to ignore Paylocity employee.", "ERROR");
      });
    };
  }

  _deleteEmployeeMapping(paylocityEmployeeId) {
    return this.$http.delete(
      this.$rootScope.apiHost + "/api/integrations/paylocity/employees/mapping/" + encodeURIComponent(paylocityEmployeeId),
      {withCredentials: true}
    );
  }

  _refreshMappingState() {
    let self = this;
    return self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/mapping", {withCredentials: true}).then(function (res) {
      self._applyMappingResponse(res.data);
      return self._refreshUnmappedUsers();
    });
  }

  removeEmployeeMapping(paylocityEmployeeId) {
    let self = this;
    const mapping = (self.employeeMapping || []).find(function (m) {
      return String(m.paylocityEmployeeId) === String(paylocityEmployeeId);
    });

    if (!mapping || !self.isMappedMapping(mapping)) {
      return;
    }

    const tcName = self.getEmployeeName(mapping.timeclerkUserId);
    const paylocityName = self.getPaylocityEmployeeName(mapping.paylocityEmployeeId);

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = "Remove Paylocity Employee Mapping";
    modalInstance.subject = (tcName || 'TimeClerk employee') + ' / ' + (paylocityName || 'Paylocity employee');
    modalInstance.message = "This will remove the mapping between the TimeClerk employee and the Paylocity employee. The Paylocity employee will return to the unmapped list.";

    modalInstance.yes = function () {
      self._deleteEmployeeMapping(paylocityEmployeeId).then(function () {
        modalInstance.dismiss();
        self._refreshMappingState();
        self.toastr.success("Employee mapping removed.", "SUCCESS");
      }, function (error) {
        modalInstance.dismiss();
        self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to remove employee mapping.", "ERROR");
      });
    };
  }

  unignoreEmployee(employee, ignoredModalInstance) {
    let self = this;
    const employeeName = (employee.firstNameInPaylocity || '') + ' ' + (employee.lastNameInPaylocity || '');

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = "Restore Paylocity Employee";
    modalInstance.subject = employeeName.trim();
    modalInstance.message = "This Paylocity employee will be removed from the ignored list and returned to the unmapped employees list.";

    modalInstance.yes = function () {
      self._deleteEmployeeMapping(employee.paylocityEmployeeId).then(function () {
        modalInstance.dismiss();
        self._refreshMappingState();
        self.toastr.success("Paylocity employee restored to unmapped list.", "SUCCESS");
        if (ignoredModalInstance && self.ignoredUsers.length === 0) {
          ignoredModalInstance.dismiss();
        }
      }, function (error) {
        modalInstance.dismiss();
        self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to restore Paylocity employee.", "ERROR");
      });
    };
  }

  openIgnoredEmployeesModal() {
    let self = this;

    const modalInstance = this.$uibModal.open({
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Ignored Paylocity Employees</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted small">These Paylocity employees are intentionally not mapped to TimeClerk users.</p>
          <div ng-if="$ctrl.ignoredUsers().length === 0" class="text-muted">No ignored employees.</div>
          <ul class="list-group" ng-if="$ctrl.ignoredUsers().length > 0" style="margin-bottom: 0;">
            <li class="list-group-item" ng-repeat="employee in $ctrl.ignoredUsers()" style="display: flex; align-items: center; justify-content: space-between;">
              <span>{{employee.firstNameInPaylocity}} {{employee.lastNameInPaylocity}}</span>
              <button class="btn btn-xs btn-default" ng-click="$ctrl.restore(employee)">
                <i class="fa fa-undo"></i> Restore
              </button>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" ng-click="$ctrl.close()">Close</button>
        </div>
      `,
      controller: ['$uibModalInstance', 'parentCtrl', function ($uibModalInstance, parentCtrl) {
        this.ignoredUsers = function () {
          return parentCtrl.ignoredUsers || [];
        };

        this.restore = function (employee) {
          parentCtrl.unignoreEmployee(employee, $uibModalInstance);
        };

        this.close = function () {
          $uibModalInstance.dismiss();
        };
      }],
      controllerAs: '$ctrl',
      resolve: {
        parentCtrl: function () {
          return self;
        }
      }
    });

    return modalInstance;
  }

  _stopSyncPolling() {
    if (this._syncPollPromise) {
      this.$interval.cancel(this._syncPollPromise);
      this._syncPollPromise = null;
    }
    this.syncProgress.inProgress = false;
  }

  _refreshAfterSync() {
    let self = this;
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/status", {withCredentials: true}).then(function (res) {
      self.paylocityIntegration = res.data;
    });
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees", {withCredentials: true}).then(function (res) {
      self.paylocityEmployees = res.data;
      self.paylocityEmployees.forEach(function (employee) {
        employee.name = (employee.firstName || employee.firstNameInPaylocity) + ' ' + (employee.lastName || employee.lastNameInPaylocity);
      });
    });
    self._refreshUnmappedUsers();
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/mapping", {withCredentials: true}).then(function (res) {
      self._applyMappingResponse(res.data);
    });
  }

  _pollSyncStatus() {
    let self = this;
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/sync/status", {withCredentials: true}).then(function (res) {
      var status = res.data || {};
      self.syncProgress.inProgress = status.inProgress === true;
      self.syncProgress.total = status.total || 0;
      self.syncProgress.completed = status.completed || 0;
      self.syncProgress.startTimeEpochMillis = status.startTimeEpochMillis || null;
      self.syncProgress.message = status.message || '';

      if (!self.syncProgress.inProgress) {
        self._stopSyncPolling();
        self._refreshAfterSync();
        self.toastr.success("Employee sync completed.", "Success");
      }
    }).catch(function () {
      self._stopSyncPolling();
      self.toastr.error("Could not get sync status.", "ERROR");
    });
  }

  _startSyncPolling() {
    let self = this;
    self._pollSyncStatus();
    self._syncPollPromise = self.$interval(function () {
      self._pollSyncStatus();
    }, 1500);
  }

  syncEmployeeData() {
    let self = this;
    if (self.syncProgress.inProgress) return;
    self.syncProgress.inProgress = true;
    self.syncProgress.message = 'Starting sync...';
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/sync", {withCredentials: true}).then(function (res) {
      self.syncProgress.message = (res.data && res.data.message) || 'Employee sync started.';
      self._startSyncPolling();
    }, function () {
      self.syncProgress.inProgress = false;
      self.toastr.error("Problem starting sync.", "ERROR");
    });
  }

  importEmployeeCache() {
    let self = this;
    if (self.syncProgress.inProgress) return;
    self.syncProgress.inProgress = true;
    self.syncProgress.message = 'Starting import...';
    self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/sync", {withCredentials: true}).then(function (res) {
      self.syncProgress.message = (res.data && res.data.message) || 'Employee sync started.';
      self._startSyncPolling();
    }, function () {
      self.syncProgress.inProgress = false;
      self.toastr.error("Problem starting import.", "ERROR");
    });
  }

  openPaylocityEmployeeSelector(employeeMapping) {
    let self = this;
    // Find the current paylocity employee object
    let currentPaylocityEmployee = null;
    if (employeeMapping.paylocityEmployeeId && this.paylocityEmployees) {
      currentPaylocityEmployee = this.paylocityEmployees.find(function(emp) {
        return emp.paylocityEmployeeId === employeeMapping.paylocityEmployeeId;
      });
    }
    
    // Create a simple prompt-like interface using $uibModal
    const modalInstance = this.$uibModal.open({
      template: `
        <div class="modal-header">
          <h3 class="modal-title">Change Paylocity Employee Mapping</h3>
        </div>
        <div class="modal-body">
          <p><strong>TimeClerk Employee:</strong> {{$ctrl.timeclerkEmployeeName}}</p>
          <label>Select Paylocity Employee:</label>
          <employee-dropdown
            ng-model="$ctrl.selectedPaylocityEmployee"
            employees="$ctrl.availablePaylocityEmployees"
            placeholder="Search Paylocity employees...">
          </employee-dropdown>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" ng-click="$ctrl.cancel()">Cancel</button>
          <button class="btn btn-primary" ng-click="$ctrl.save()" ng-disabled="!$ctrl.selectedPaylocityEmployee">Save</button>
        </div>
      `,
      controller: [
        '$uibModalInstance', 'timeclerkEmployeeName', 'paylocityEmployees', 'currentPaylocityEmployee', 'employeeMapping', 'employeeMappings',
        function($uibModalInstance, timeclerkEmployeeName, paylocityEmployees, currentPaylocityEmployee, employeeMapping, employeeMappings) {
          this.timeclerkEmployeeName = timeclerkEmployeeName;
          this.selectedPaylocityEmployee = currentPaylocityEmployee;

          paylocityEmployees.forEach(function(emp) {
            emp.name = emp.firstNameInPaylocity + ' ' + emp.lastNameInPaylocity;
          });
          
          // Only show Paylocity employees that are not already mapped to a different TimeClerk user
          this.availablePaylocityEmployees = paylocityEmployees.filter(function(emp) {
            var alreadyMappedToOther = (employeeMappings || []).some(function(m) {
              return m.paylocityEmployeeId === emp.paylocityEmployeeId && m.timeclerkUserId !== employeeMapping.timeclerkUserId;
            });
            return !alreadyMappedToOther;
          });

          this.save = function() {
            $uibModalInstance.close(this.selectedPaylocityEmployee);
          };

          this.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        }
      ],
      controllerAs: '$ctrl',
      resolve: {
        timeclerkEmployeeName: function() {
          return self.getEmployeeName(employeeMapping.timeclerkUserId);
        },
        paylocityEmployees: function() {
          return self.paylocityEmployees || [];
        },
        currentPaylocityEmployee: function() {
          return currentPaylocityEmployee;
        },
        employeeMapping: function() {
          return employeeMapping;
        },
        employeeMappings: function() {
          return self.employeeMapping || [];
        }
      }
    });

    modalInstance.result.then(function(selectedEmployee) {
      if (selectedEmployee) {
        employeeMapping.paylocityEmployee = selectedEmployee;
        self.updatePaylocityMapping(employeeMapping);
      }
    });
  }

  syncEmployeeByPaylocityId(paylocityEmployeeId) {
    let self = this;
    this.$http.get(this.$rootScope.apiHost + "/api/integrations/paylocity/employees/" + paylocityEmployeeId+"/sync", {withCredentials: true}).then(function (success) {
      self.toastr.success("Employee successfully synced with Paylocity.", "SUCCESS");
      // Refresh the employee mapping data to get updated lastSynced date
      self.$http.get(self.$rootScope.apiHost + "/api/integrations/paylocity/employees/mapping", {withCredentials: true}).then(function (success) {
        self._applyMappingResponse(success.data);
      });
    }, function (failure) {
      self.toastr.error("Failed to sync employee with Paylocity.", "ERROR");
    });
  }

}

export default PaylocityEmployeeMapping;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/employee-mapping/paylocity-employee-mapping.controller.js